var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("node-view-wrapper", [
    _c(
      "div",
      {
        class: _vm.writerClasses,
        on: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            return _vm.removeAIInput($event)
          }
        }
      },
      [
        _c("div", { class: _vm.inputContainerClasses }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue"
              }
            ],
            class: _vm.inputClasses,
            attrs: {
              type: "text",
              disabled: _vm.quotaAILimitReached,
              placeholder: _vm.translate.labelPlaceholderInput
            },
            domProps: { value: _vm.inputValue },
            on: {
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k(
                      $event.keyCode,
                      "backspace",
                      undefined,
                      $event.key,
                      undefined
                    )
                  ) {
                    return null
                  }
                  return _vm.handleBackspace($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleSubmit($event)
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputValue = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sellsy-ai-writer__button",
              attrs: { disabled: _vm.isDisabled },
              on: { click: _vm.handleSubmit }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "13",
                    height: "9",
                    viewBox: "0 0 13 9",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d:
                        "M7.89852 0.192714C7.65477 0.448811 7.65477 0.865134 7.89852 1.12254L10.371 3.71898H0.623535C0.278535 3.71898 -0.00146484 4.01316 -0.00146484 4.37564C-0.00146484 4.73811 0.278535 5.0323 0.623535 5.0323H10.371L7.89852 7.63004C7.65477 7.88614 7.65477 8.30246 7.89852 8.55856C8.14227 8.81466 8.53852 8.81466 8.78227 8.55856L12.316 4.84449C12.4398 4.71579 12.4998 4.54505 12.4985 4.37564C12.4998 4.20622 12.4398 4.03549 12.316 3.90678L8.78227 0.192714C8.53852 -0.0633835 8.14227 -0.0633835 7.89852 0.192714Z",
                      fill: "currentColor"
                    }
                  })
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.quotaAILimitReached
          ? _c("div", { staticClass: "sellsy-ai-writer__container-limit" }, [
              _c(
                "div",
                {
                  staticClass: "sellsy-ai-writer__container-limit__icon-label"
                },
                [
                  _c("img", {
                    staticClass: "ai-icon",
                    attrs: {
                      src: "/ressources/logged/img/icon/svg/ai-warning.svg",
                      alt: "ai icon"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-small-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.translate.limit_quota) +
                          "\n                "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sellsy-ai-writer__container-limit__actions" },
                [
                  _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.translate.labelButtonContactUs,
                      size: "small"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleContactUs($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.translate.labelButtonClose,
                      size: "small"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleClose($event)
                      }
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }